// UserContext.js
import { createContext } from "react";

const SuperSignalRContext = createContext({});
export default SuperSignalRContext;
